import React, { useEffect, useState } from "react";
import { Stack } from "react-bootstrap";
import styled from "styled-components";
//import GenericAdminFilters from "./_GenericAdminFilters";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { MissInfoReport } from "../../components/MissInfo";
import AdminReportSmsList from "./AdminReportSmsList";
import { useAuth } from "../../Context/AuthContext";
import { httpClient } from "../../utils/HttpClient";
import FiltersAdmin from "../../components/reports/admin/summaryByDate/FiltersAdmin";

const Divider = styled.div`
  background: #dfdfdf;
  width: 100%;
  height: 1px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const ReportSmsByDateAdmin = () => {
  const Auth = useAuth();
  const userData = Auth.getSessionData();
  const [reportData, setReportData] = useState(null);
  const [periodStr, setPeriodStr] = useState("");
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    return () => {      setReportData(null);
    }
  }, [periodStr]);
  const getDataReport = (filters) => {
    setReportData(null);
    setLoading(true);
    const URI = ApiEndpoint + "administration/report/mtmessages";

    httpClient(
      "POST",
      URI,
      {
        idcustomer: filters.idcustomer,
        idpartner: filters.idpartner,
        from: filters.dateFrom,
        to: filters.dateTo,
        carrier: filters.idcarrier,
        shortcode: filters.idshortcode,
        onlyread: "false",
      },
      userData.token
    )
      .then(function (response) {
        setReportData(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <>
      <div className="">
        <Stack direction="horizontal" gap={2}>
          <div>
            <h2>Detalle de Mensajes por fecha</h2>
            <h3>Todos los Mensajes enviados.</h3>
          </div>
        </Stack>

        {/* <div className="ReportDate">
          <GenericAdminFilters
            onRefresh={getDataReport}
            setPeriodStr={setPeriodStr}
            loading={loading}
          />
        </div> */}

        <FiltersAdmin
          onRefresh={getDataReport}
          setPeriodStr={setPeriodStr}
          loading={loading}
        />

        <Divider />
        {reportData ? (
          <AdminReportSmsList
            periodStr={periodStr}
            listMessages={reportData}
            isLoading={loading}
          />
        ) : (
          <MissInfoReport />
        )}
      </div>
    </>
  );
};

export default ReportSmsByDateAdmin;
